module.exports = __webpack_public_path__ + "media/customizations/royaloaks/back-4842a1d73ab44295d9fd9a538247fb92.jpg";